import BaseStore from '@/store/base-store'

const options = {}
export default new BaseStore('brands', options)



// WEBPACK FOOTER //
// ./src/store/modules/brands.store.js